export default __webpack_public_path__ + "static/media/forest.3febb11f.svg";